import React from 'react';
import styles from './Learn.module.css';
import Sidebar from '../Sidebar/Sidebar';
import * as utils from '../../utils/utils';

export default class Learn extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			learnText: '',
			isLoading: false,
			errorText: '',
			infoText: 'Share what you want to learn, and we will shape a practical, personalized course path.',
		};
	}

	componentDidMount() {
		if (!utils.isLoggedIn()) {
			window.location.href = '/signin';
		}
	}

	onInputChange = (event) => {
		this.setState({
			learnText: event.target.value,
			errorText: '',
		});
	};

	handleTextKeyDown = (event) => {
		if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
			this.handleGenerateCourses();
		}
	};

	handleGenerateCourses = () => {
		const learnText = this.state.learnText.trim();

		if (learnText === '') {
			this.setState({
				errorText: 'Please describe what you want to learn before generating courses.',
			});
			return;
		}

		this.setState({
			isLoading: true,
			errorText: '',
			infoText: 'Generating your personalized learning path...',
		}, () => {
			window.location.href = `/my-courses?topic=${encodeURIComponent(learnText)}`;
		});
	};

	render() {
		const {
			learnText,
			isLoading,
			errorText,
			infoText,
		} = this.state;

		return (
			<div className={styles.pageContainer}>
				<Sidebar />

				<div className={styles.glowTop} />
				<div className={styles.glowBottom} />

				<div className={styles.layoutShell}>
					<section className={styles.headerPanel}>
						<div className={styles.brandBadge}>HQVibe</div>
						<h1 className={styles.title}>What do you want to learn today?</h1>
						<p className={styles.subtitle}>Describe briefly to generate courses tailored to you.</p>

						<div className={styles.userRow}>
							<span className={styles.userCaption}>Focus on goals, your current level, and the outcomes you want.</span>
						</div>
					</section>

					<section className={styles.mainCardPanel}>
						<div className={styles.stepRow}>
							<div className={`${styles.stepDot} ${styles.stepDotActive}`} />
							<div className={styles.stepLine} />
							<div className={styles.stepDot} />
						</div>

						<h2 className={styles.formTitle}>Learning Intent</h2>
						<p className={styles.formText}>{infoText}</p>

						<div className={styles.form}>
							<div className={styles.fieldGroup}>
								<label className={styles.label} htmlFor='learn-topic-text'>Tell us what you want to learn</label>
								<textarea
									id='learn-topic-text'
									name='learnText'
									className={styles.textArea}
									placeholder='Example: I want to learn practical system design for backend interviews and apply it to Node.js services.'
									value={learnText}
									onChange={this.onInputChange}
									onKeyDown={this.handleTextKeyDown}
								/>
							</div>

							<button className={styles.primaryButton} onClick={this.handleGenerateCourses} disabled={isLoading}>
								{isLoading ? 'Generating...' : 'Generate Courses'}
							</button>

							<p className={styles.hintText}>Tip: Press Ctrl/Cmd + Enter to generate quickly.</p>
						</div>

						{
							errorText !== '' &&
							<div className={styles.errorBox}>{errorText}</div>
						}
					</section>
				</div>
			</div>
		);
	}
}
